import { useParams } from 'react-router-dom';
import {
  ButtonPseudo,
  SidePanel,
  SidePanelLoader,
  SidePanelType,
  ButtonPrimary,
} from '@ui/src';
import { useAppSelector } from '@store';
import { CustomerStatus, OrganizationType } from '../types';
import BeneficiaryContractContent from '../../../components/common/beneficiary/contract';
import useBeneficiaryContracts from './hooks/use-contracts';

const BeneficiaryContract = ({ type }: { type: OrganizationType }) => {
  const { customerId, beneficiaryId, contractId } = useParams();

  const { beneficiaryContract, beneficiary } = useAppSelector(
    (state) => state.customerBeneficiaries,
  );
  const { baseCurrency } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { baseInformation: individualBaseInformation } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );
  const { baseInformation: corporateBaseInformation } = useAppSelector(
    (state) => state.corporateCustomers.info.general,
  );
  const {
    currenciesList: currencies,
    currencies: currenciesList,
    activePermissions,
  } = useAppSelector((state) => state.root);

  const {
    isLoading,
    isFetching,
    panelState,
    setPanelState,
    onRowClick,
    formattedData,
    control,
    errors,
    getFile,
    downloadId,
    downloadError,
    downloadInProgress,
    selectedCurrency,
    setSelectedCurrency,
    uploadedDocuments,
    downloadIsFetching,
    panelIsOpen,
    handleClose,
    updateError,
    updateInProgress,
    updateStatusInProgress,
    updateContractAction,
  } = useBeneficiaryContracts({
    beneficiaryContract,
    activePermissions,
    beneficiaryId,
    contractId,
    type,
    customerId,
    currenciesList,
  });

  const organizationStatus =
    type === OrganizationType.INDIVIDUAL
      ? individualBaseInformation?.status
      : corporateBaseInformation?.status;

  let content;

  if (isLoading || isFetching) {
    content = <SidePanelLoader />;
  } else {
    content = (
      <BeneficiaryContractContent
        panelState={panelState}
        setPanelState={setPanelState}
        onRowClick={onRowClick}
        formattedData={formattedData}
        control={control}
        errors={errors}
        beneficiaryContract={beneficiaryContract}
        baseCurrency={baseCurrency}
        getFile={getFile}
        downloadId={downloadId}
        downloadError={downloadError}
        downloadInProgress={downloadInProgress}
        currencies={currencies}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        currenciesList={currenciesList}
        organizationStatus={organizationStatus}
        uploadedDocuments={uploadedDocuments}
        beneficiary={beneficiary}
        downloadIsFetching={downloadIsFetching}
      />
    );
  }

  return (
    <SidePanel
      isOpen={panelIsOpen}
      onClose={handleClose}
      type={SidePanelType.Customers}
      title="Contract details"
      errorSidepanel={updateError}
      sidepanelExpandedKey="beneficairy-contract-details"
      footer={
        <>
          {beneficiaryContract?.status !== 'REJECTED' &&
            organizationStatus !== CustomerStatus.CLOSED && (
              <ButtonPrimary
                text={
                  updateInProgress || updateStatusInProgress
                    ? 'Loading...'
                    : 'Save'
                }
                disabled={
                  updateInProgress ||
                  updateStatusInProgress ||
                  beneficiaryContract?.status === 'REJECTED'
                }
                onClick={updateContractAction}
                bold
              />
            )}

          <ButtonPseudo text="Close" onClick={handleClose} bold />
        </>
      }
      closeOnClickOutside
    >
      {content}
    </SidePanel>
  );
};

export default BeneficiaryContract;
